module.exports = __webpack_public_path__ + "static/media/logo@2x.48e23249.png";